{
  "version": 1,
  "asset_id": "4debaac4-5c43-4bd8-a1b3-0c58bd02186b",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/4debaac4-5c43-4bd8-a1b3-0c58bd02186b/silivri-hizli-elektrikci-7-24-dukkan-3.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/4debaac4-5c43-4bd8-a1b3-0c58bd02186b/silivri-hizli-elektrikci-7-24-dukkan-3.jpg",
  "original_filename": "silivri-hizli-elektrikci-7-24-dukkan-3.jpg",
  "size": 180037,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:26:41Z"
}
